import ga from '../utils/ga'

export const reportItemAddedToFavourite = (itemID: number) => {
  ga('send', 'event', 'Item', 'click', 'favourite: added', itemID)
}

export const reportItemRemovedFromFavourite = (itemID: number) => {
  ga('send', 'event', 'Item', 'click', 'favourite: removed', itemID)
}

export const reportItemAddedToCollection = (itemID: number) => {
  ga('send', 'event', 'Item', 'click', 'collection: added', itemID)
}

export const reportItemRemovedFromCollection = (itemID: number) => {
  ga('send', 'event', 'Item', 'click', 'collection: removed', itemID)
}

export const reportCollectionCreated = () => {
  ga('send', 'event', 'Item', 'click', 'collection: created')
}

export const setGAUserID = (id: number | string) => {
  if (!id) {
    return
  }

  let idString = id
  if (typeof id === 'number') {
    idString = id.toString()
  }
  ga('set', 'userId', id)
  ga('set', 'dimension1', idString)
  ga('send', 'event', 'User Authentication', 'signed-in', 'shopfront')
}

export const reportModalPageView = ({
  title,
  page
}: {
  title: string
  page: string
}) => {
  ga('send', {
    hitType: 'pageview',
    page,
    title
  })
}
